import clsx from "clsx";
import { ErrorMessage, Field, FormikProps } from "formik";

type ForgotPasswordEmailProps = {
  formikProps: FormikProps<{ email: string }>;
};

export const ForgotPasswordEmail: React.FC<ForgotPasswordEmailProps> = ({ formikProps }: ForgotPasswordEmailProps) => {
  return (
    <>
      {/* begin::Form group */}
      <div className="fv-row mb-10">
        <label className="form-label fw-bolder text-gray-900 fs-6" htmlFor="email">
          Email
        </label>
        <Field
          className={clsx(
            "form-control bg-transparent",
            { "is-invalid": formikProps.touched.email && formikProps.errors.email },
            {
              "is-valid": formikProps.touched.email && !formikProps.errors.email,
            }
          )}
          type="email"
          name="email"
          id="email"
          autoComplete="username"
          data-test-id="forgot-password-form__email-input"
        />
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">
            <ErrorMessage name="email" />
          </div>
        </div>
      </div>
      {/* end::Form group */}
    </>
  );
};
